<template lang="">
  <div>
    <ToastPrime />
    <DialogPrime
      :header="$t('logger')"
      v-model:visible="displayLogger"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '75vw' }"
    >
      <template #footer>
        <ListBox :options="items" :virtualScrollerOptions="{ itemSize: 31 }" listStyle="height:400px" />
      </template>
    </DialogPrime>
    <DataTablePrime
      v-if="showTable"
      :value="dataToShow[this.partType]"
      dataKey="id"
      responsiveLayout="scroll"
      class="p-datatable-sm"
    >
      <h4>{{ getPartTypeName(partType) }}</h4>
      <ColumnPrime
        v-for="col of columns"
        :field="col.field"
        :header="col.header"
        :key="col.field"
        sortable
      ></ColumnPrime>
      <ColumnPrime :header="$t('actions')" :style="{ width: '200px' }">
        <template #body="slotProps">
          <ButtonPrime icon="pi pi-pencil" class="action-button mybutton" @click="modifyConf(slotProps.data)" />
          <ButtonPrime
            v-if="hasInfo(slotProps.data)"
            icon="pi pi-info"
            class="action-button mybutton"
            @click="showInfo(slotProps.data)"
          />
          <ButtonPrime icon="pi pi-trash" class="action-button mybutton" @click="deleteHandler(slotProps.data)" />
        </template>
      </ColumnPrime>
    </DataTablePrime>

    <div v-if="partType === 'MainEngineEmissions'">
      <AddMainEngineEmissionsComponent
        @savedElement="onSavedElement"
        @errorSavingElement="errorSavingElement"
        :editElementId="mainEngineElementToEdit"
      ></AddMainEngineEmissionsComponent>
      <div>
        <ButtonPrime class="p-button add-button" @click="editConfig()">+ {{ $t("addAnother") }}</ButtonPrime>
      </div>
    </div>
    <div v-else-if="partType === 'AuxiliaryEngineEmissions'">
      <AddAuxEngineEmissionsComponent
        @savedElement="onSavedElement"
        @errorSavingElement="errorSavingElement"
        :editElementId="auxEngineElementToEdit"
      ></AddAuxEngineEmissionsComponent>
      <div>
        <ButtonPrime class="p-button add-button" @click="editConfig()">+ {{ $t("addAnother") }}</ButtonPrime>
      </div>
    </div>
    <div v-else-if="partType === 'MainEngineEnergySavings'">
      <AddMainEngineEnergySavingsComponent
        @savedElement="onSavedElement"
        @errorSavingElement="errorSavingElement"
        :editElementId="mainEngineSavingsElementToEdit"
      ></AddMainEngineEnergySavingsComponent>
      <div>
        <ButtonPrime class="p-button add-button" @click="editConfig()">+ {{ $t("addAnother") }}</ButtonPrime>
      </div>
    </div>
    <div v-else-if="partType === 'AuxiliaryEngineEnergySavings'">
      <AddAuxEngineEnergySavingsComponent
        @savedElement="onSavedElement"
        @errorSavingElement="errorSavingElement"
        :editElementId="auxEngineSavingsElementToEdit"
      ></AddAuxEngineEnergySavingsComponent>
      <div>
        <ButtonPrime class="p-button add-button" @click="editConfig()">+ {{ $t("addAnother") }}</ButtonPrime>
      </div>
    </div>
    <div v-else>
      <p>{{ $t("pendingComponent") }}</p>
    </div>
  </div>
  <DialogPrime
        v-model:visible="dialogDisplay"
        :breakpoints="{ '960px': '25vw', '640px': '25vw' }"
        :style="{ width: '25vw' }">
      <template #header>
        <h3 v-if="dialogHeader == 'AuxiliaryEngineEmissions' ">{{ $t("headerAuxiliaryEngineEmissions") }}  {{ itemToDelete.name }}?</h3>
        <h3 v-if="dialogHeader == 'AuxiliaryEngineEnergySavings' ">{{ $t("headerAuxiliaryEngineEnergySavings") }}  {{ itemToDelete.type }}?</h3>
        <h3 v-if="dialogHeader == 'MainEngineEmissions' ">{{ $t("headerMainEngineEmissions") }}  {{ itemToDelete.name }}?</h3>
        <h3 v-if="dialogHeader == 'MainEngineEnergySavings' ">{{ $t("headerMainEngineEnergySavings") }}  {{ itemToDelete.type }}?</h3>
      </template>
        <div class="formgrid grid">
          <ButtonPrime
            :label="$t('cancel')"
            class="p-button actionButton"
            v-tooltip.top="$t('cancel')"
            @click="dialogDisplay=false"
          />
          <ButtonPrime
            :label="$t('confirm')"
            class="p-button actionButton"
            v-tooltip.top="$t('confirm')"
            @click="deleteShipPart(itemToDelete)"
          />
        </div>
    </DialogPrime>
</template>
<script>
import AddMainEngineEmissionsComponent from "@/components/AddMainEngineEmissionsComponent.vue";
import AddAuxEngineEmissionsComponent from "@/components/AddAuxEngineEmissionsComponent.vue";
import AddMainEngineEnergySavingsComponent from "@/components/AddMainEngineEnergySavingsComponent.vue";
import AddAuxEngineEnergySavingsComponent from "@/components/AddAuxEngineEnergySavingsComponent.vue";
import store from "@/store/index";
import ShipPartService from "@/services/ShipPartService";
import { ToastSeverity } from "primevue/api";
import HandlerShipPartTable from "@/plugins/HandlerShipPartTable"

export default {
  data: () => {
    return {
      showTable: true,
      displayBasic: false,
      columns: null,
      conf: {},
      displayLogger: false,
      items: [],
      mainEngineElementToEdit: null,
      auxEngineElementToEdit: null,
      mainEngineSavingsElementToEdit: null,
      auxEngineSavingsElementToEdit: null,
      dialogDisplay: false,
      itemToDelete: {},
      dialogHeader: "",
    };
  },
  components: {
    AddMainEngineEmissionsComponent,
    AddAuxEngineEmissionsComponent,
    AddMainEngineEnergySavingsComponent,
    AddAuxEngineEnergySavingsComponent,
  },
  props: {
    fields: String,
    partType: String,
  },
  methods: {
    onSavedElement(elementType, isNew) {
      console.log("onSavedElement", elementType, isNew);

      var summary = "Created new " + elementType + " successfully";
      if (!isNew) {
        summary = "Updated " + elementType + " successfully";
      }
      this.$toast.add({
        severity: ToastSeverity.SUCCESS,
        closable: true,
        summary: summary,
        life: 3000,
      });

      this.showTable = false;
      setTimeout(this.showTableAgain, 1000);
    },
    errorSavingElement(elementType, errors) {
      this.$toast.add({
        severity: ToastSeverity.ERROR,
        closable: true,
        summary: "Error guardando " + elementType + ": " + errors,
        life: 3000,
      });
    },
    modifyConf(item) {
      console.log(item);
      const newObj = {
        ...item,
      };

      if (this.partType == "MainEngineEmissions") {
        this.mainEngineElementToEdit = newObj;
      } else if (this.partType == "AuxiliaryEngineEmissions") {
        this.auxEngineElementToEdit = newObj;
      } else if (this.partType == "MainEngineEnergySavings") {
        this.mainEngineSavingsElementToEdit = newObj;
      } else if (this.partType == "AuxiliaryEngineEnergySavings") {
        this.auxEngineSavingsElementToEdit = newObj;
      }
    },
    editConfig() {
      console.log("editConfig", this.partType);

      if (this.partType == "MainEngineEmissions") {
        this.mainEngineElementToEdit = {};
      } else if (this.partType == "AuxiliaryEngineEmissions") {
        this.auxEngineElementToEdit = {};
      } else if (this.partType == "MainEngineEnergySavings") {
        this.mainEngineSavingsElementToEdit = {};
      } else if (this.partType == "AuxiliaryEngineEnergySavings") {
        this.auxEngineSavingsElementToEdit = {};
      }
    },
    deleteHandler(item) {
      if(Object.prototype.hasOwnProperty.call(item, "bogTotal")){
        this.dialogHeader = "AuxiliaryEngineEmissions"
      }else if(Object.prototype.hasOwnProperty.call(item, "feffpaeeff")){
        this.dialogHeader = "AuxiliaryEngineEnergySavings"
      }else if(Object.prototype.hasOwnProperty.call(item, "pme")){
        this.dialogHeader = "MainEngineEmissions"
      }else if(Object.prototype.hasOwnProperty.call(item, "ppeffal")){
        this.dialogHeader = "MainEngineEnergySavings"
      }
      this.itemToDelete = item;
      this.dialogDisplay = true;
    },
    deleteShipPart(item) {
      this.showTable = false;
      this.dialogDisplay = false;
      console.log("deleteShipPart", item);
      ShipPartService.getInstance().deleteShipPart(store.getters.currentShip.id, store.getters.currentConfiguration.id, this.partType, item.id);
      setTimeout(this.showTableAgain, 1000);
    },
    showTableAgain() {
      this.showTable = true;
    },
    showInfo(item) {
      console.log("ShowInfo", item);
      this.items = item.logElement;
      this.displayLogger = true;
    },
    hasInfo(item) {
      console.log("HasInfo", item);
      return item.logElement && item.logElement.length > 0;
    },
    getPartTypeName(partType) {
      
      let result = partType;
      
      const text = HandlerShipPartTable.getTranslationText();

        if (partType === "MainEngineEmissions") {
          result = text.mainEngine;
        } else if (partType === "AuxiliaryEngineEmissions") {
          result =  text.auxiliaryEngine;
        } else if (partType === "MainEngineEnergySavings") {
          result = text.MainEngineEnergySavings;
        } else if (partType === "AuxiliaryEngineEnergySavings") {
          result = text.AuxiliaryEngineEnergySavings;
        }
       


      return result;
    },
  },
  computed: {
    dataToShow() {
      return store.getters.currentConfiguration;
    },
    languageStare() {
      return store.getters.languateState;
    },
  },
  watcher: {
    
  },
  created() {
    this.columns = [];
    this.fields.split(",").forEach((element) => {
      this.columns.push({ field: element, header: element });
    });
  },
};
</script>
<style scoped>
#add-button {
  margin: 20px;
}
div.table {
  height: 80%;
}

.mybutton {
  margin: 2px !important;
}
</style>
